import { useState } from 'react';
import { useTranslate, List, Datagrid, TextField, NumberField } from 'react-admin';
import { Box, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { usePermissions } from '../../auth/permissions';
import { LIST_ITEM_MAX_COUNT } from '../../config';
import UploadFileIcon from '@mui/icons-material/UploadFile';

export const AggregateList = () => {
	const translate = useTranslate();
	const { isAdmin, isUser } = usePermissions();
	
	const pageTitle = translate('resources.aggregate.list');
	const systemName = translate('system.name');
	const [type, setType] = useState('variety');
	const [open, setOpen] = useState(false);
	
	const handleTypeChange = (event: any) => {
		setType(event.target.value);
	};
	
	const ListActions = () => (
		<Box sx={{ width: '100%', margin: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
			<FormControl sx={{ minWidth: 120, width: 'auto', mt: 1 }} size="small">
				<InputLabel id="type-select-label">集計種別</InputLabel>
				<Select
					labelId="type-select-label"
					id="type-select"
					value={type}
					label="集計種別"
					onChange={handleTypeChange}
				>
					<MenuItem value="variety">品名別</MenuItem>
					<MenuItem value="market">市場別</MenuItem>
				</Select>
			</FormControl>
			<Button
				variant="contained"
				onClick={() => setOpen(true)}
				startIcon={<UploadFileIcon />}
			>
				アップロード
			</Button>
		</Box>
	);
	
	const handleClose = () => {
		setOpen(false);
	};

	const handleUpload = () => {
		// ここにファイルのアップロード処理を実装します
		console.log('File upload logic goes here');
		handleClose();
	};
	
	return (
		<Card>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<List title={pageTitle} perPage={LIST_ITEM_MAX_COUNT} filter={{ type: type }} actions={<ListActions />} queryOptions={{ meta: { mode: 'kanri' } }}>
				<Datagrid
					rowClick={() => false}
					bulkActionButtons={false}
					isRowSelectable={() => false}
					sx={{
						'& .RaDatagrid-headerCell:not(:last-of-type)': {
							borderRight: '1px solid #e0e0e0',
						},
						'& .RaDatagrid-rowCell:not(:last-of-type)': {
							borderRight: '1px solid #e0e0e0',
						},
					}}
				>
					{type === 'variety' ? (
						<TextField source="variety" label={translate('resources.aggregate.fields.variety')} />
					) : (
						<TextField source="market" label={translate('resources.aggregate.fields.market')} />
					)}
					<NumberField source="quantity" label={translate('resources.aggregate.fields.quantity')} />
					<NumberField source="price" label={translate('resources.aggregate.fields.price')} options={{ style: 'currency', currency: 'JPY' }} />
					<NumberField source="amount" label={translate('resources.aggregate.fields.amount')} options={{ style: 'currency', currency: 'JPY' }} />
				</Datagrid>
			</List>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>ファイルアップロード</DialogTitle>
				<DialogContent>
					{/* ここにファイル選択コンポーネントなどを配置します */}
					<p>CSVまたはPDFをアップロードしてください。</p>
					<input type="file" />
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} variant='outlined'>キャンセル</Button>
					<Button onClick={handleUpload} variant="contained">アップロード</Button>
				</DialogActions>
			</Dialog>
		</Card>
	);
};

export default AggregateList;